import { useMemo } from 'react'
import { prop, path, map, omit } from 'ramda'

import { useFilterData } from 'app/common/ui-components/filter'

import periodFilter from './filter/period'
import getDefaultPeriod from './filter/period/defaultPeriod'


const toInt = (val: string) => parseInt(val, 10)

type Result = {
  limit: number
  offset: number
  id?: number | null
  date_from?: string
  date_to?: string
  year_id?: number | null
  month?: number | null
  food_mode?: Array<string>
  klasses_ids?: Array<number>
  status?: Array<number>
  building_ids?: Array<number>
}

type AdditionalParams = {
  limit: number
  offset: number
  id?: number | null
}

type FilterApplied = Record<string, Array<string>>

export default function useFilterParams(
  { limit, offset, id }: AdditionalParams,
  foodModeEnable: boolean,
): Result {
  const [{ applied: filterApplied }] = useFilterData() as unknown as [
    { applied: FilterApplied | null },
    ...unknown[],
  ]

  const result = useMemo(() => {
    const [defaultDateFrom, defaultDateTo] = getDefaultPeriod()
    const additional = { limit, offset, id }
    const dateFrom = (path([periodFilter, 0], filterApplied) as string | undefined) || defaultDateFrom
    const dateTo = (path([periodFilter, 1], filterApplied) as string | undefined) || defaultDateTo

    const additionalWithPeriod: Result = {
      ...additional,
      date_from: dateFrom,
      date_to: dateTo,
    }

    if (!filterApplied) {
      return additionalWithPeriod
    }

    const params: Result = {
      ...additionalWithPeriod,
      year_id: toInt(path(['year', 0], filterApplied) as string) || null,
      food_mode: prop('foodMode', filterApplied) as Array<string> | undefined,
      klasses_ids: map(toInt, prop('class', filterApplied) as Array<string>),
      status: map(toInt, prop('status', filterApplied) as Array<string>),
      building_ids: map(toInt, prop('building', filterApplied) as Array<string>),
    }

    return foodModeEnable ? params : omit(['food_mode'], params) as Result
  }, [filterApplied, limit, offset, id, foodModeEnable])

  return result
}
